var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_2377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9482 5.09124C25.0061 5.50904 23.9937 5.79148 22.931 5.91844C24.0156 5.26831 24.8486 4.23879 25.2408 3.01207C24.2258 3.6141 23.1016 4.05129 21.9049 4.2869C20.9467 3.26589 19.5814 2.62793 18.0705 2.62793C15.1692 2.62793 12.8171 4.98002 12.8171 7.88107C12.8171 8.29284 12.8635 8.69372 12.9531 9.07824C8.58714 8.85918 4.7163 6.76777 2.12531 3.58949C1.67312 4.36538 1.41409 5.26776 1.41409 6.23051C1.41409 8.05302 2.34153 9.66096 3.75108 10.603C2.88996 10.5758 2.07995 10.3394 1.37165 9.94596C1.37128 9.96791 1.3712 9.98986 1.3712 10.012C1.3712 12.5573 3.18199 14.6805 5.58521 15.1631C5.14436 15.2831 4.68027 15.3473 4.20118 15.3473C3.86267 15.3473 3.53358 15.3144 3.21281 15.2531C3.88132 17.3401 5.82137 18.859 8.12014 18.9014C6.32223 20.3103 4.05713 21.1502 1.59592 21.1502C1.17189 21.1502 0.753719 21.1253 0.342773 21.0768C2.66761 22.5673 5.4289 23.4369 8.39553 23.4369C18.0582 23.4369 23.3421 15.4322 23.3421 8.49022C23.3421 8.26247 23.337 8.03591 23.3269 7.81064C24.3532 7.06997 25.2439 6.14471 25.9482 5.09124Z",
    fill: "#69ACE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_2377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6054,
    height: 25.6054,
    fill: "white",
    transform: "translate(0.342773 0.229492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.9ba5b3392c907d3b683190aa43a41354.svg";
export { ForwardRef as ReactComponent };